import sharedStyles from '../compare-and-favourite-bar.module.css'
import { SvgIcon } from '@cinch-labs/design-system'
import cx from 'classnames'

export interface FavouriteCTAProps {
  isSaved: boolean
  onClick: () => void
}

export const FavouriteCTA = ({ isSaved, onClick }: FavouriteCTAProps) => {
  const FAVOURITE_CAR = 'Add car to favourites'
  const UNFAVOURITE_CAR = 'Remove car from favourites'

  return (
    <div className={sharedStyles.ctaWrapper}>
      <button
        type="button"
        aria-label={isSaved ? UNFAVOURITE_CAR : FAVOURITE_CAR}
        className={cx(sharedStyles.ctaButton, isSaved && sharedStyles.toggled)}
        onClick={onClick}
      >
        <SvgIcon name={isSaved ? 'heart' : 'heart-outline'} size={16} />
        Favourite
      </button>
    </div>
  )
}
